export default {
      id: "clearSmall-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#clearSmall-usage",
      toString: function () {
        return this.url;
      }
    }